import script from "./IpdBilling.vue?vue&type=script&setup=true&lang=js"
export * from "./IpdBilling.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__